import React from "react";

import styles from "./ListCard.module.scss";
import { SampleProps } from "../../types/sample";
import moment from "moment";
import { Link } from "react-router-dom";
import { route } from "../../static/route";

type Props = {
  sample: SampleProps;
};

const ListCard = ({ sample }: Props) => {
  return (
    <div className={styles.ListCard}>
      <h5 className="text-primary-1 text-lg font-semibold">
        કામ નું આઇડી : {sample.id}
      </h5>

      <div className="flex flex-col gap-3 mt-5">
        <p className="text-primary-1 text-sm font-semibold">
          પાર્ટી : {sample.party_name}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          આઈટમ : {sample.item_name}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          પ્રોસેસ : {sample.process_name}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          યુનિટ :{" "}
          {sample.unit === 1 ? "KG" : sample.unit === 2 ? "Piece" : "Pair"}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          {sample.unit === 3 ? "જોડી" : sample.unit === 2 ? "નંગ" : "વજન"} :{" "}
          {sample.qty}
        </p>
        {sample.status === 1 && (
          <>
            <p className="text-primary-1 text-sm font-semibold">
              ડિલિવર કરેલ{" "}
              {sample.unit === 3 ? "જોડી" : sample.unit === 2 ? "નંગ" : "વજન"} :{" "}
              {sample.delivered_qty}
            </p>

            <p className="text-primary-1 text-sm font-semibold">
              ડિલિવર કરેલ તારીખ :{" "}
              {moment(sample.delivered_date, "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY hh:mm A"
              )}
            </p>

            <p className="text-primary-1 text-sm font-semibold">
              અમાઉન્ટ : {sample.amount}
            </p>
          </>
        )}
      </div>

      <Link to={route.sampleDetails + `/${sample.id}`}>
        <button
          className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-1xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
          type="button"
        >
          કામ ની વિગતો જુઓ
        </button>
      </Link>
    </div>
  );
};
export default ListCard;
